export enum EnumTipoContrato {
  TipoContratoInvalido = 0,
  ClienteFinal = 11,
  Trade = 14,
  Gnl = 16,
  ClienteComercial = 17,
  Transporte = 18,
  Distribucion = 19,
  ClienteExtendido = 20,
  Financiero = 23,
  Electricidad = 1011,
  CanalizadoSinIEH = 1012,
  CanalizadoNm3 = 1013,
  NoTelemedidoDiario = 1014,
  VCO = 1015,
  TresPaginas = 1016,
  CuatroPaginas = 1017
}
